import api from './client';

export const uploadCompleteSector = data => api('/sectors', { method: 'POST', body: data });
export const replaceCompleteSector = (sectorId, data) => api(`/sectors/${sectorId}`, { method: 'PUT', body: data });
export const uploadEntities = (entities, sectorId) => api(`/resources/${sectorId}/entities`, { method: 'POST', body: { entities } });
export const getSyncedSectors = () => api('/sectors').then(({ sectors }) => sectors);
export const getSectorEntities = sectorId => api(`/sectors/${sectorId}`).then(({ entities, share }) => ({ entities, share }));
export const updateEntity = (entityId, entityType, update, sectorId = entityId) => api(
  entityType === 'sector' ? `/sectors/${sectorId}` : `/resources/${sectorId}/entities/${entityType}/${entityId}`,
  { method: 'PATCH', body: update },
);
export const updateEntities = (entities, sectorId) => api(`/resources/${sectorId}/entities`, { method: 'PATCH', body: { entities } });
export const deleteSector = sectorId => api(`/sectors/${sectorId}`, { method: 'DELETE' });
export const deleteEntities = (entities, sectorId) => api(`/resources/${sectorId}/entities`, { method: 'DELETE', body: { entities } });
